import { TipoPlantao } from '../core/_models'

let tiposMap: Record<string, { nome: string; cor: string }> = {}

export const setTiposPlantaoFromApi = (tipos: TipoPlantao[]) => {
  tipos.forEach((tipo) => {
    tiposMap[tipo.Nome as string] = {
      nome: tipo.Nome as string,
      cor: tipo.Cor as string,
    }
  })
}

export const getCorPlantaoByNome = (nome: string) => {
  return tiposMap[nome].cor
}
